'use client';

import { FC } from 'react';

import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Icon } from '@ravago/shared/radiance/components/icon/components/Icon/Icon';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface LeadTimeMessageProps {
   hasMtsLocal: boolean;
   from?: 'rfq' | 'order-now';
}

export const LeadTimeMessage: FC<LeadTimeMessageProps> = ({ hasMtsLocal, from }) => {
   const translate = useTranslations();

   return (
      <Box backgroundColor="surface-1" items="center" spacing={{ y: 'lg', x: 'md' }} borderRadius="largest" direction="row">
         <Icon size="heading-4" color="primary" icon="truck" />
         <Box direction="column" gap="3xs">
            <Typography component="span" variant="body-highlight">
               {hasMtsLocal
                  ? translate('request-for-quotation.lead-time.mts-local-title')
                  : translate('request-for-quotation.lead-time.delivery-on-request')}
            </Typography>
            <Typography whiteSpace="normal" component="span" variant="small" color="strong">
               {from === 'order-now'
                  ? translate('request-for-quotation.lead-time.order-now-description')
                  : translate('request-for-quotation.lead-time.description')}
            </Typography>
         </Box>
      </Box>
   );
};
